// src/hooks/usePersistentAgentFilter.js
// One source of truth for the pipelines' "Viewing: <agent>" eye filter: defaults
// to the current user's own leads ("Me") and persists the last pick per user +
// pipeline so it sticks across visits.
import { useEffect, useState } from "react";

export const agentFilterKey = (userId, pipelineKey) =>
  `${pipelineKey}ViewAgent:${userId || "anon"}`;

// `fallback` lets a caller default to something other than "self" (e.g. the
// Deals Board defaults to "all" — it's the team's board, not "mine") without
// changing behavior for callers that omit it.
export const initialAgentFilter = (userId, pipelineKey, fallback) => {
  try {
    return (
      localStorage.getItem(agentFilterKey(userId, pipelineKey)) ||
      fallback ||
      userId ||
      "all"
    );
  } catch (e) {
    return fallback || userId || "all";
  }
};

export function usePersistentAgentFilter(userId, pipelineKey, fallback) {
  const [viewAgent, setViewAgent] = useState(() =>
    initialAgentFilter(userId, pipelineKey, fallback),
  );
  useEffect(() => {
    try {
      localStorage.setItem(agentFilterKey(userId, pipelineKey), viewAgent);
    } catch (e) {
      /* storage unavailable — non-fatal */
    }
  }, [userId, pipelineKey, viewAgent]);
  return [viewAgent, setViewAgent];
}
